<template>
  <v-app>
    <FESnackbar />
    <CoreToolbar />
    <FEBanner />
    <MainContainer />
    <CoreFooter />
  </v-app>
</template>

<script>
import CoreToolbar from './Toolbar'
// import CoreDrawer from './Drawer'
import CoreFooter from './Footer'
import MainContainer from './MainContainer'
import FESnackbar from './FESnackbar'
import FEBanner from './FEBanner'

export default {
  name: 'CoreLayout',
  components: {
    CoreToolbar,
    // CoreDrawer,
    CoreFooter,
    MainContainer,
    FESnackbar,
    FEBanner
  },
  data: () => ({})
}
</script>
